<script lang="ts">
  import { initFileUploadValue } from "../../atoms/forms/FileUpload";

  import FormWithLabel from "../../molecules/FormWithLabel.svelte";

  import SectionBoard from "../../molecules/SectionBoard.svelte";
  import { ApiService } from "../../services/api.service";
  import BlueButton from "../BlueButton.svelte";

  const label = "CSVインポート";
  let loading = false;
  let file = initFileUploadValue();

  function handleFile() {}

  async function create() {
    loading = true;
    console.log(file);
    const client = ApiService.createClient();
    await client.post(`/recruitments/import`, file);
    loading = false;
  }
</script>

<SectionBoard>
  <h2 class="font-semibold">
    {label}
  </h2>

  <div class="mt-2">
    <FormWithLabel inputType="file" input={handleFile} {file} />
  </div>

  <BlueButton rounded klass="mt-4" click={create} {loading}>
    登録する
  </BlueButton>
</SectionBoard>
